import { Link } from "react-router-dom";
import { RotateCcw, ArrowRight } from "lucide-react";

export function ReviewReminder({ count }) {
  if (!count) return null;
  return (
    <Link
      to="/vocabulaire?revoir=1"
      data-testid="home-review-reminder"
      className="rise rise-1 flex items-center gap-4 rounded-2xl bg-red-50 border-2 border-red-200 hover:border-red-400 p-4 transition-colors"
    >
      <div className="shrink-0 w-12 h-12 rounded-xl bg-red-600 text-white grid place-items-center">
        <RotateCcw className="w-6 h-6" />
      </div>
      <div className="flex-1">
        <div className="font-display text-2xl font-bold leading-none" data-testid="home-review-count">
          {count} mot{count > 1 ? "s" : ""} à revoir
        </div>
        <div className="text-sm text-slate-600">2 minutes de fiches</div>
      </div>
      <ArrowRight className="w-6 h-6 text-red-600" />
    </Link>
  );
}
